import React, { Component, ReactElement } from "react";

interface Props {
	title: string;
	extraClass?: string;
	action?: ReactElement;
}

class FormSection extends Component<Props> {
	static defaultProps = {
		extraClass: "",
	};

	render() {
		return (
			<div className={ "card " + this.props.extraClass }>
				<div className="card-header">
                            <span>
                                { this.props.title }
                            </span>
					{ this.props.action }
				</div>
				<div className="card-body">
					{ this.props.children }
				</div>
			</div>
		);
	}
}

export default FormSection;
